import { TablePagination } from "@mui/material";
import MaterialTable from "material-table";
import React, { forwardRef } from "react";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import {
  ContentLoader,
  ContentPagination,
  ContentTableList,
  useStyles,
} from "./MyInsightListComponent.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import LogoutIcon from "@mui/icons-material/Logout";
import moment from "moment";
import ErrorIcon from "@mui/icons-material/Error";
import { theme as themeConfig } from "../../themes/themes";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import FiltersByCases from "../FiltersByCases/FiltersByCases";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PropTypes from "prop-types";

const MyInsightListComponent = forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <>
      <FiltersByCases
        ref={ref}
        myListStatuses={props.myListStatuses}
        handleChangeStatus={props.handleChangeStatus}
        rDateValue={props.rDateValue}
        handleChangeDate={props.handleChangeDate}
        activeHightPriority={props.activeHightPriority}
        setActiveHightPriority={props.setActiveHightPriority}
        handleSearch={props.handleSearch}
        showCards={props.showCards}
        setShowCards={props.setShowCards}
        resetFilters={props.resetFilters}
      />
      {props.loadingFirstInsights ||
        props.loadingAfterInsights ||
        props.loadingBeforeInsights ? (
        <ContentLoader>
          <PointersLine color={themeConfig.button.primary} />
        </ContentLoader>
      ) : null}
      {(!props.loadingFirstInsights ||
        !props.loadingAfterInsights ||
        !props.loadingBeforeInsights) && (
          <ContentTableList>
            {!props.showCards && (
              <MaterialTable
                title=""
                columns={[
                  {
                    title: "Case ID",
                    field: "idCase",
                    type: "string",
                    headerStyle: {
                      columnWidth: "5%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "5%",
                      textAlign: "center",
                    },
                  },
                  {
                    title: "High Priority",
                    field: "highPriority",
                    type: "string",
                    headerStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    render: (rowData) => (
                      <Tooltip title={"High Priority"} style={{ zIndex: 0 }}>
                        <IconButton>
                          {rowData.highPriority ? (
                            <ErrorIcon
                              style={{ fontSize: "16px", color: themeConfig.status.error }}
                            />
                          ) : (
                            ""
                          )}
                        </IconButton>
                      </Tooltip>
                    ),
                  },
                  {
                    title: "Form",
                    field: "form",
                    type: "string",
                    headerStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    render: (rowData) => rowData?.idFormNavigation?.name,
                  },
                  {
                    title: "Submission Date",
                    field: "submissionDate",
                    type: "string",
                    headerStyle: {
                      columnWidth: "30%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "30%",
                      textAlign: "center",
                    },
                    render: (rowData) =>
                      moment(rowData.createDate).format("YYYY-MM-DD"),
                  },
                  {
                    title: "Being managed by",
                    field: "beingManageBy",
                    type: "string",
                    headerStyle: {
                      columnWidth: "30%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "30%",
                      textAlign: "center",
                    },
                    render: (rowData) =>
                      rowData?.handlerUserInfo?.ccmsuser
                        ? rowData.handlerUserInfo.ccmsuser
                        : "...",
                  },
                  {
                    title: "State",
                    field: "status",
                    headerStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "10%",
                      textAlign: "center",
                    },
                    type: "string",
                  },
                  {
                    title: "",
                    field: "internal_action",
                    headerStyle: {
                      columnWidth: "5%",
                      textAlign: "center",
                    },
                    cellStyle: {
                      columnWidth: "5%",
                      textAlign: "center",
                    },
                    render: (rowData) =>
                      rowData && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            zIndex: 0,
                          }}
                        >
                          {rowData?.hasAttachment && (
                            <Tooltip title={"Attach File"}>
                              <IconButton>
                                <AttachFileIcon style={{ fontSize: "16px" }} />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Detail">
                            <IconButton
                              className={classes.delete}
                              onClick={() => props.handleSeeDetails(rowData)}
                            >
                              <LogoutIcon
                                style={{ fontSize: "16px", color: themeConfig.text.primary }}
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                  },
                ]}
                data={props.myInsightsList}
                options={{
                  tableLayout: "auto",
                  search: false,
                  paging: false,
                  maxBodyHeight: 450,
                  headerStyle: {
                    zIndex: 1,
                    fontWeight: "bold",
                    backgroundColor: themeConfig.neutral.gray[900],
                    textAlign: "center",
                  },
                  cellStyle: {
                    fontSize: "14px",
                    padding: "5px 10px",
                    textAlign: "center",
                  },
                  rowStyle: (rowData) => ({
                    backgroundColor:
                      rowData.tableData.id % 2 === 0 ? "#FFFFFF" : "#F0F0F0",
                  }),
                }}
              ></MaterialTable>
            )}
            {props.showCards && (
              <ViewControlMenu
                identity={"my-insights"}
                title={""}
                showCards={props.showCards}
                setShowCards={props.setShowCards}
                list={props.myInsightsList}
                isAgent={false}
                handleSeeDetails={props.handleSeeDetails}
              />
            )}
            {props.myInsightsList.length > 0 ? (
              <ContentPagination>
                <TablePagination
                  component="div"
                  style={{ display: "flex", justifyContent: "center" }}
                  count={props.allPages}
                  page={props.page}
                  onPageChange={props.handleChangePage}
                  rowsPerPage={props.rowsPerPage}
                  rowsPerPageOptions={props.rowsPerPageOptions}
                  onRowsPerPageChange={props.handleChangeRowsPerPage}
                />
              </ContentPagination>
            ) : (
              <></>
            )}
          </ContentTableList>
        )}
    </>
  );
});

export default MyInsightListComponent;

MyInsightListComponent.propTypes = {
  props: PropTypes.object.isRequired,
  ref: PropTypes.object.isRequired,
};
